import * as React from "react";
import { PrismicContext } from "./PrismicProvider.js";

var usePrismicContext = function usePrismicContext() {
  return React.useContext(PrismicContext) || {};
};

export { usePrismicContext };